import get from 'lodash/get'

const getValue = (path, defaultValue) => {
  const value = get(window, `__appState.settings.${path}`)

  if (value === undefined || value === null) {
    return defaultValue
  }

  return value
}

const getRequiredValue = (path, defaultValue) => {
  const value = getValue(path, defaultValue)

  return value ? value : defaultValue
}

const toBoolean = value => {
  if (value === null || value === undefined) {
    return false
  }

  switch (typeof value) {
    case 'boolean':
      return value
    case 'number':
      return !!value
  }

  switch (value.toString().toLowerCase()) {
    case 'true':
    case '1':
      return true
    case 'false':
    case '0':
      return false
  }

  return !!value
}

const getBooleanValue = (path, defaultValue) => {
  return toBoolean(getValue(path, defaultValue))
}

export {
  getValue,
  getBooleanValue,
  getRequiredValue,
  toBoolean,
}
